var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBarcodeRead = function SvgBarcodeRead(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M1.201 2.4h6v1.2h-4.8v4.8h-1.2v-6m4.8 4.8h1.2v9.6h-1.2zm2.4 0h1.2v9.6h-1.2zm8.4 9.6V7.2h1.2v9.6zm-4.8-9.6v9.6h-1.2V7.2zm1.8 0h1.2v9.6h-1.2zm8.4-4.8h.6v6h-1.2V3.6h-4.8V2.4h5.4m-21 19.2v-6h1.2v4.8h4.8v1.2h-6m21 0h-5.4v-1.2h4.8v-4.8h1.2v6z"
  })));
};
export default SvgBarcodeRead;